<template>
  <div class="d-flex justify-content-center" style="margin-top: 1vh">
    <button
      id="previous-step"
      class="btn pj-link-green"
      :class="{ 'fs-3 pj-ss-btn': isSelfService }"
      @click="previousStep"
    >
      {{ t("SHARED.PREVIOUS_STEP") }}
    </button>
  </div>
</template>
<script setup lang="ts">
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { computed } from "vue";
import { getPreviousStep } from "@/apps/merchant3/state-manager";
import { isSelfServiceCart } from "@/apps/merchant3/helpers/self-service";

const emit = defineEmits(["route-changed"]);
const { t } = useI18n();
const router = useRouter();

const previousStep = () => {
  const currentStep = router.currentRoute.value.name;
  if (!currentStep) {
    return;
  }
  const step = getPreviousStep(currentStep);
  if (step) {
    router.push(step);
    emit("route-changed");
  }
};

const isSelfService = computed(() => {
  return isSelfServiceCart();
});
</script>
